import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchBlogsData as fetchBlogsDataApi,
  fetchBlogById as fetchBlogByIdApi,
} from "../../api"; // Import fetchBlogsData from api.js

// Async thunk for fetching blogs data
export const fetchBlogsData = createAsyncThunk(
  "blogs/fetchBlogsData",
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await fetchBlogsDataApi();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch blogs data");
    }
  }
);

export const fetchBlogById = createAsyncThunk(
  "blogs/blogsById",
  async (id, { rejectWithValue }) => {
    try {
      const data = await fetchBlogByIdApi({ id }); // Assuming fetchBlogByIdApi accepts an object with `id`
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch blog by ID");
    }
  }
);

const blogsSlice = createSlice({
  name: "blogs",
  initialState: {
    data: null, // Store blog data
    loading: false, // Loading state
    error: null, // Error message
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlogsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogsData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchBlogsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchBlogById.pending, (state) => {
        state.loadingSingle = true;
        state.errorSingle = null;
      })
      .addCase(fetchBlogById.fulfilled, (state, action) => {
        state.loadingSingle = false;
        state.singleBlog = action.payload;
      })
      .addCase(fetchBlogById.rejected, (state, action) => {
        state.loadingSingle = false;
        state.errorSingle = action.payload;
      });
  },
});

export const { resetError } = blogsSlice.actions;
export default blogsSlice.reducer;
